// onDirectDebitListPageMatch.js - Orchestrator for direct debit list page (Sammel-Lastschrift button + dialog).

const onDirectDebitListPageMatch = () => {
  console.log('Lux Inject: Running onDirectDebitListPageMatch')

  if (typeof Lux_initializeDirectDebitSammelButton === 'function') {
    Lux_initializeDirectDebitSammelButton()
  } else {
    console.error('Lux_initializeDirectDebitSammelButton function not found!')
  }
}
